// // AJAX Stuff
import state from './state';
import { initBarba } from './barba/barba';

import FontFaceObserver from 'fontfaceobserver';

import Cursor from './components/Cursor';

import SmoothScroll from './util/SmoothScroll';

import Valis from './util/Valis';
import * as components from './components';

import gsap from 'gsap';
import ModalLinks from './util/ModalLinks';
import MarketoForms from './util/MarketoForms';
const mediaLoaded = require('imagesloaded');
const sansFont = new FontFaceObserver('DM Sans');
const serifFont = new FontFaceObserver('Playfair Display');

const buildOnce = () => {
  state.valis = new Valis();
  const componentElements = gsap.utils.toArray(
    document.querySelectorAll('[data-component]')
  );
  state.valis.initComponents(components, componentElements);
  document.querySelector('html').classList.remove('block-ui');

  const cursor = document.querySelector('.cursor');
  if (cursor) {
    state.cursor = new Cursor();
    state.cursor.init();
  }
};

state.isFirstLoad = true;

// Load Events
window.addEventListener('load', () => {
  document.querySelector('html').classList.add('block-ui');

  const devEnv = new Promise(resolve => {
    setTimeout(resolve, window.app.environment === 'development' ? 1500 : 0);
  });

  Promise.all([sansFont.load(), serifFont.load(), devEnv]).then(() => {
    state.queries = {
      xs: 0,
      sm: '(min-width: 576px)',
      md: '(min-width: 768px)',
      lg: '(min-width: 992px)',
      xl: '(min-width: 1200px)',
      xxl: '(min-width: 1600px)',
      xxxl: '(min-width: 1920px)',
      xxxxl: '(min-width: 2560px)',
      reduceMotion: '(prefers-reduced-motion: reduce)',
    };

    mediaLoaded(document.querySelector('main'), () => {
      window.scrollTo(0, 0);

      state.smoothScroll = new SmoothScroll();
      state.smoothScroll.init();

      state.modalLinks = new ModalLinks();
      state.modalLinks.init();

      if (history.scrollRestoration) {
        history.scrollRestoration = 'manual';
      }

      initBarba();
      buildOnce();
    });

    window.addEventListener('orientationchange', event => {
      window.location.reload();
    });
  });
});



//////////////////
// WEBPACK FOOTER
// ./scripts/main.js
// module id = 19
// module chunks = 0